<div
  class="pagination-container"
  [ngClass]="{
    full: isFull,
    loading: isLoading,
    'with-playlists': isPlaylist,
  }">
  <ng-content></ng-content>
  @if (!isFull) {
    <div class="bottom">
      <div class="display-more-wrapper">
        @if (!isLoading) {
          <button class="display-more-btn" (click)="onDisplayMore()">
            <span class="icon icon-plus"></span>
            <span class="display-more-text">{{
              'browse.displayMore' | translate
            }}</span>
          </button>
        } @else if (useLoader) {
          <ng-container>
            <div class="loading-container">
              <app-loader></app-loader>
            </div>
          </ng-container>
        }
      </div>
      <div class="hidden-part"></div>
    </div>
  }
</div>
